import { isEmpty } from 'lodash';

const checkFormUpsertValidation = (form, errors) => {
  const { name, accessType, operatorMenu } = form;

  if (!accessType) return false;

  switch (accessType.label) {
    case 'Desktop Website':
      return !isEmpty(name) && !isEmpty(accessType) && !isEmpty(operatorMenu) && isEmpty(errors);

    case 'Mobile Website':
    default:
      return !isEmpty(name) && !isEmpty(accessType) && isEmpty(errors);
  }
};

export default checkFormUpsertValidation;
